import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { TokenService } from '../../services/token/token.service';
import { AuthenticationService } from '../../services/authentication/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class IsNotFullyAuthenticatedGuard implements CanActivate {
  constructor(
    private router: Router,
    private tokenService: TokenService,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(): Observable<boolean> {
    return this.authenticationService.verifyUser().pipe(
      map(() => {
        if (
          this.authenticationService.isAuthenticated() &&
          !this.tokenService.isEmailVerified()
        ) {
          return true;
        } else if (this.authenticationService.isAuthenticated()) {
          // TODO: return to the page you were previously on???
          this.router.navigateByUrl('home');
          return false;
        }
        this.router.navigateByUrl('login');
        return false;
      }),
      catchError(() => {
        this.router.navigateByUrl('login');
        return of(false);
      })
    );
  }
}
